import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Theme,
  Typography,
  useMediaQuery,
} from '@mui/material';

import warningImage from '../../assets/imgs/warningImage.png';

type Props = {
  open: boolean;
  onClose: () => void;
  handleAction: () => void;
  title: string;
  labelButton: string;
  labelCloseButton?: string;
};

function ConfirmLeaveDialog({
  open,
  onClose,
  handleAction,
  title,
  labelButton,
  labelCloseButton = 'Sair desta página',
}: Props) {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );
  return (
    <Dialog open={open} maxWidth="md">
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          padding: '32px 20px 0',
          overflow: 'hidden',
          minHeight: '465px',
        }}>
        <img src={warningImage} width={185} height={185} />
        <Typography
          sx={{ padding: '0px 64px' }}
          variant="h4"
          textAlign="center">
          {title}
        </Typography>
        <Typography
          maxWidth={430}
          textAlign="center"
          sx={{ fontSize: '0.875rem' }}>
          Ao sair desta página todas as alterações realizadas serão perdidas.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          justifyContent: isMobile ? 'space-between' : 'center',
          padding: '0 0 40px 0',
          height: isMobile ? '140px' : undefined,
        }}
        disableSpacing={isMobile}>
        <Button
          size="large"
          variant="contained"
          onClick={onClose}
          sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
          {labelButton}
        </Button>
        <Button
          size="large"
          variant="outlined"
          color="secondary"
          onClick={handleAction}
          sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
          {labelCloseButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmLeaveDialog;
